var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "cf-flex cf-items-start cf-gap-3",
    class: [_vm.isSender && 'cf-flex-row-reverse', _vm.sendStatus === _vm.MESSAGE_SEND_STATUS.PENDING && 'cf-opacity-50 cf-pointer-events-none cf-select-none']
  }, [!_vm.hideAvatar ? [_c('CoreTooltip', {
    attrs: {
      "text": _vm.senderName,
      "placement": "top"
    }
  }, [_vm._t("avatar", function () {
    return [_vm.avatarText || _vm.avatarUrl ? _c('CoreAvatar', {
      directives: [{
        name: "html-safe",
        rawName: "v-html-safe",
        value: _vm.avatarText,
        expression: "avatarText"
      }],
      attrs: {
        "src": _vm.avatarUrl
      }
    }) : _vm._e()];
  })], 2)] : _vm._e(), _c('div', {
    staticClass: "cf-max-w-[70%] cf-flex cf-flex-col cf-gap-1"
  }, [!_vm.hideName && _vm.senderName ? _c('div', {
    staticClass: "cf-text-xs cf-text-muted cf-flex cf-gap-2 cf-items-end",
    class: {
      'cf-flex-row-reverse': _vm.isSender
    }
  }, [_vm.senderName ? _c('span', {
    staticClass: "cf-text-onyx cf-leading-[0.75]"
  }, [_vm._v(" " + _vm._s(_vm.senderName) + " ")]) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "cf-break-all cf-px-5 cf-py-3 cf-rounded cf-flex cf-flex-col cf-gap-3 cf-relative cf-overflow-hidden",
    class: _vm.bubbleBackgroundColor
  }, [_vm.eventName && _vm.messageType === _vm.CHAT_TYPE.EVENT || _vm.$slots['header-actions'] ? _c('div', {
    staticClass: "cf-flex cf-justify-between cf-items-center cf-mb-2"
  }, [_vm.eventName && _vm.messageType === _vm.CHAT_TYPE.EVENT ? _c('div', [_vm._v(" " + _vm._s(_vm.eventName) + " ")]) : _vm._e(), _vm.$slots['header-actions'] ? _c('div', [_vm._t("header-actions")], 2) : _vm._e()]) : _vm._e(), _vm.message || _vm.$slots['message'] ? _c('div', {
    class: [_vm.messageType === _vm.CHAT_TYPE.EVENT ? 'cf-text-muted' : 'cf-text-eerie-black']
  }, [_vm._t("message", function () {
    return [_c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.parseHtml(_vm.message))
      }
    })];
  })], 2) : _vm._e(), _vm.articles.length > 0 ? _c('div', _vm._l(_vm.articles, function (article) {
    return _c('div', {
      key: article.id,
      class: _vm.articleClasses
    }, [_c('a', {
      attrs: {
        "href": article.url,
        "target": "_blank"
      }
    }, [_c('b', [_vm._v(_vm._s(article.title))]), _c('p', {
      staticClass: "cf-text-slate-600 cf-w-full cf-line-clamp-2"
    }, [_vm._v(" " + _vm._s(article.bodyNoHtml) + " ")])])]);
  }), 0) : _vm._e(), _c('ChatBubbleAttachments', {
    attrs: {
      "attachments": _vm.attachments
    }
  }), _c('span', {
    staticClass: "cf-text-[9px] cf-leading-none cf-font-thin cf-text-black/70 tw-tracking-widest",
    class: [_vm.isSender ? 'cf-text-right' : '']
  }, [_vm._v(" " + _vm._s(_vm.sentDateFormatted) + " ")])], 1), _c('div', {
    staticClass: "cf-text-xs cf-text-deep-rose cf-leading-none cf-user-select-none cf-flex cf-gap-2 cf-items-center cf-select-none cf-text-right cf-justify-end"
  }, [_vm.sendStatus === _vm.MESSAGE_SEND_STATUS.FAILED ? [_c('div', [_vm._v(" Not delivered. "), _c('span', {
    staticClass: "cf-text-blue-500 cf-cursor-pointer",
    on: {
      "click": _vm.onRetry
    }
  }, [_vm._v(" Click to retry. ")])]), _c('div', {
    on: {
      "click": _vm.onDelete
    }
  }, [!_vm.isDeletingFailedMessage ? _c('IconTrash', {
    staticClass: "cf-text-[15px] cf-cursor-pointer"
  }) : _c('IconLoading', {
    staticClass: "cf-text-[15px] cf-text-midnight/50"
  })], 1)] : _vm._e(), _vm.sendStatus === _vm.MESSAGE_SEND_STATUS.PENDING ? _c('IconLoading', {
    staticClass: "cf-text-[15px] cf-text-midnight/50 cf-cursor-pointer"
  }) : _vm._e()], 2), _vm.seen ? _c('ChatSeenIndicator', {
    attrs: {
      "seen-date-unix": _vm.seenDateUnix
    }
  }) : _vm._e(), _vm.$slots['footer'] ? _c('div', {
    class: [_vm.isSender ? 'cf-text-right' : '']
  }, [_vm._t("footer")], 2) : _vm._e()], 1)], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };